<template>
    <div>
        <div class="card" v-if="display === 'table'">
            <div class="card-body" style="overflow-x: auto;">
                <div v-if="loading">
                    <i class="fa fa-spin fa-spinner"></i> Initializing
                </div>
                <div v-else>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>{{ y_axis_name }}</th>
                                <th v-for="(total, time_interval) in x_axis_totals">
                                    {{ time_interval }}
                                </th>
                                <th class="btn-light">
                                    Total
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="result in results">
                                <td>{{ result[y_axis_name] ? result[y_axis_name] : '-- No '+y_axis_name+' --'  }}</td>
                                <td v-for="(total, time_interval) in result.data">
                                    {{ total }}
                                </td>
                                <td class="btn-light">
                                    {{ result.total }}
                                </td>
                            </tr>
                            <tr class="bg-light">
                                <td>Totals:</td>
                                <td v-for="(total, time_interval) in x_axis_totals">
                                    {{ total }}
                                </td>
                                <td>
                                    {{ all_time_total }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="card" v-else-if="display === 'graph' || display === 'graph_column'">
            <div class="card-body">
                <div v-if="loading">
                    <i class="fa fa-spin fa-spinner"></i> Initializing
                </div>
                <div v-else>
                    <highcharts id="highcharts-canvas" :options="options" style="min-height: 800px;" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        props: {
            dateLabel: {
                type: String,
                default: null,
            },

            filters: {
                type: Object,
                required: true,
            },

            report: {
                type: Object,
                default(){
                    return null;
                },
            }
        },

        data() {
            return {
                loading: false,
                all_time_total: null,
                x_axis_totals: [],
                results: [],
            }
        },

        computed: {
            labels(){
                //Setup
                return Object.keys(this.x_axis_totals);
            },

            series(){
                //Setup
                var series = [];

                //Build each
                for (var i = 0; i < this.results.length; i++)
                {
                    //Build the Data
                    var data = [];

                    //Setup
                    var keys = Object.keys(this.results[i].data);

                    //Build Each
                    for (var j = 0; j < keys.length; j++)
                    {
                        //Push the Data Point
                        data.push({y: this.results[i].data[keys[j]]});
                    }

                    //Append
                    series.push({
                        name: (this.results[i][this.y_axis_name] ? this.results[i][this.y_axis_name] : '-- No '+this.y_axis_name+'--'),
                        data: data,
                    });
                }

                //Send it
                return series;
            },

            options(){
                //Build the Title
                var title = 'Incidents By '+this.y_axis_name;

                //Check for Saved Report
                if(this.report && this.report.report_name)
                {
                    //Set Title
                    title = this.report.report_name;
                }

                //Send it
                return {
                    chart: {
                        type: (this.display === 'graph' ? 'bar' : 'column'),
                    },
                    title: {
                        text: title,
                    },
                    subtitle: {
                            text: (this.dateLabel ? this.dateLabel : '')
                        },
                    xAxis: {
                        categories: this.labels
                    },
                    yAxis: {
                        title: {
                            text: 'Incidents By '+this.y_axis_name
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                formatter: function(){
                                    return this.point.series.name+': '+this.point.y;
                                }
                            }
                        }
                    },
                    legend: {
                        layout: 'horizontal',
                        align: 'right',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0,
                        floating: false,
                        borderColor: '#dddddd',
                        borderWidth: 1,
                    },
                    series: this.series,
                    // tooltip: {
                    //     formatter: function() {
                    //         //Send it
                    //         var html = 'Incident Type: <b>'+ this.series.name + '</b><br/>' +
                    //                 'Date: <b>'+ this.x + '</b><br/>' +
                    //                 'Total Incidents: <b>'+ this.y + '</b><br/>';

                    //         //Check for empty or undefined
                    //         if(typeof this.point.options.injuries == 'undefined' || Object.keys(this.point.options.injuries).length == 0)
                    //         {
                    //             return html;
                    //         }

                    //         //Setup
                    //         var elemKeys = Object.keys(this.point.options.injuries);

                    //         //Loop and Add items
                    //         for(const key of elemKeys)
                    //         {
                    //             //Helper
                    //             var elem = this.point.options.injuries[key];

                    //             //Append the HTML
                    //             html += elem.text + ': <b>' + elem.total + '</b><br>';
                    //         };

                    //         //Send it
                    //         return html;
                    //     }
                    // },
                }
            },

            y_axis_name(){
                return this.filters['group_by'][0].name;
            },

            display(){
                //Send it
                return this.filters['display'][0].id;
            },
        },

        watch: {

        },

        methods: {
            getData(export_results = false) {
                //Set loading
                this.loading = true;

                //Build the filters
                var filters = this.buildFilters();

                //SEt the flag
                filters.export = export_results;

                //Send it
                this.$http
                    .get('reports/incidents/totals', filters)
                    .then(response => {
                        //Check for Export
                        if(export_results)
                        {
                            //Open Export
                            window.open(response.data);

                            //Stop
                            return;
                        }

                        //Set all the data
                        this.x_axis_totals = response.data.x_axis_totals;
                        this.results = response.data.results;
                        this.all_time_total = response.data.all_time_total;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            getFilters(){
                //Send it
                return this.filters;
            },

            buildFilters(){
                //Setup
                var filters = filterExtractor.extractFilters(this.filters);

                //Append the Various Inputs
                filters.y_axis_id = this.filters['group_by'][0].id;
                filters.y_axis_name = this.y_axis_name;
                filters.x_axis_time = this.filters['interval'][0].id;

                //Send it
                return filters;
            },
        },

        mounted() {
            //Graph it
            this.getData();
        }
    }
</script>

